import { connect } from 'react-redux'
import PillboxMenu from '../components/PillboxMenu.jsx'
import { actions as selectableActions, selectors as selectableSelectors } from '@features/selectable/index.js'

const mapStateToProps = (state, props) => {
  const { namespace, scope } = props
  const options = selectableSelectors.getOptions(state, props)
  const value = selectableSelectors.getValue(state, props)
  return {
    namespace,
    scope,
    options,
    value,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChange: function (namespace, scope, value) {
      const payload = { namespace, scope, value }
      dispatch(selectableActions.changeValue(payload))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PillboxMenu)
